/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgResourceService = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h20v16h-9v2h4v2H7v-2h4v-2H2zm2 2v12h16V4z" />
        <path d="M17 11V9h-1.141a3.956 3.956 0 0 0-.425-1.02l.808-.808-1.414-1.415-.808.809A3.956 3.956 0 0 0 13 6.141V5h-2v1.141a3.956 3.956 0 0 0-1.02.425l-.808-.809-1.415 1.415.809.808c-.186.316-.33.656-.425 1.02H7v2h1.141c.095.364.239.704.425 1.02l-.809.808 1.414 1.414.809-.808c.316.186.656.33 1.02.425V15h2v-1.141a3.991 3.991 0 0 0 1.02-.425l.808.808 1.414-1.414-.808-.808c.187-.316.33-.656.425-1.02zm-5 1a2 2 0 1 1 .001-4.001A2 2 0 0 1 12 12z" />
      </g>
    </g>
  </Icon>
);
export { SvgResourceService as ResourceService };
